import React from 'react';
import PropTypes from 'prop-types';
import JourneySearchDate from '../index';

const InboundJourneySearchDate = ({
  booking,
  isReturnJourney,
  cheapestFares,
  currency,
  subscriptionStartDate,
  subscriptionEndDate,
  leg = [],
  isExchangingSingleLegOfSNCBSummated,
  testIdSuffix
}) => (
  <JourneySearchDate
    id="inbound"
    dateToChange="inboundDate"
    oppositeJourney={booking?.outbound || []}
    booking={booking}
    isReturnJourney={isReturnJourney}
    cheapestFares={cheapestFares}
    currency={currency}
    subscriptionStartDate={subscriptionStartDate}
    subscriptionEndDate={subscriptionEndDate}
    leg={leg}
    isExchangingSingleLegOfSNCBSummated={isExchangingSingleLegOfSNCBSummated}
    testIdSuffix={testIdSuffix}
  />
);

InboundJourneySearchDate.propTypes = {
  booking: PropTypes.shape({
    outbound: PropTypes.array
  }),
  isReturnJourney: PropTypes.bool,
  cheapestFares: PropTypes.shape({
    cheapestFares: PropTypes.arrayOf(
      PropTypes.shape({
        date: PropTypes.string,
        price: PropTypes.number
      })
    )
  }),
  currency: PropTypes.string,
  subscriptionStartDate: PropTypes.string,
  subscriptionEndDate: PropTypes.string,
  leg: PropTypes.array,
  isExchangingSingleLegOfSNCBSummated: PropTypes.bool,
  testIdSuffix: PropTypes.string
};

export default InboundJourneySearchDate;
